import React, { useEffect, useState, useContext } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useNavigate, useLocation } from "react-router-dom";
import { Outlet } from "react-router-dom";
import ProductGroups from "./ProductGroups";
import ProdCatNameListSelector from "./ProdCatNameListSelector";
import ProdNameListSelector from "./ProdNameListSelector";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAddressCard } from "@fortawesome/free-regular-svg-icons";
import { faList, faPlusSquare } from "@fortawesome/free-solid-svg-icons";
import ListWithFilters from "../ListWithFilters/ListWithFilters";
import SocketContext from "../../contexts/SocketContext";

import "./Products.css";
import ProdSelector from "./ProdSelector";
import SearchField from "../SearchField/SearchField";
import AddProdModal from "./AddProdModal";
// import { Socket } from "socket.io-client";

const Products = () => {
  // General
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();

  // Socket
  const { socket } = useContext(SocketContext);

  // States to hold Data and ListData
  const [data, setData] = useState();
  const [listdata, setListData] = useState();
  const [reloaddata, setReloaddata] = useState(false);

  // ProdGroup States
  const [productGroups, setProductGroups] = useState(); //all products grouped by Product Group
  const [showProdGroups, setShowProdGroups] = useState(true);
  const [selectedProdGroup, setSelectedProdGroup] = useState("");
  const [singleProdGroupData, setSingleProdGroupData] = useState({}); //stores all products belonging to a selected group
  const [prodGroupEdits, setProdGroupEdits] = useState({
    prodGroupID: "",
    productGroup: "",
  });

  // ProdCatName States
  const [selectedProdCatName, setSelectedProdCatName] = useState();
  const [selectedProdCatNameID, setSelectedProdCatNameID] = useState();
  const [editingPCN, setEditingPCN] = useState(false);
  const [prodCatNameEdits, setProdCatNameEdits] = useState({
    prodCatNameID: "",
    prodCatName: "",
  });
  const [newProdCatName, setNewProdCatName] = useState();
  const [singleProdCatNameData, setSingleProdCatNameData] = useState(); //stores all products belonging to a selected prodcatname

  // ProdName States
  const [selectedProdName, setSelectedProdName] = useState();
  const [editingPN, setEditingPN] = useState(false);
  const [prodNameEdits, setProdNameEdits] = useState();
  const [singleProdNameData, setSingleProdNameData] = useState(); //stores all products belonging to a selected prodName

  // Select Producer
  const [selectedProducer, setSelectedProducer] = useState();

  // Select Product
  const [selectedProduct, setSelectedProduct] = useState();

  // Show Hide
  const [showProdDetails, setShowProdDetails] = useState(false); //prod details
  const [viewlist, setViewlist] = useState(true); // view list
  const [showAddProdCatName, setShowAddProdCatName] = useState(false); //prod cat name selector
  const [showAddProdModal, setShowAddProdModal] = useState(false); // add prod modal

  // Filter Input
  const [productfilter, setProductfilter] = useState("");

  // Join and Leave Products Room
  useEffect(() => {
    socket.emit("joinproductsroom");
    return () => {
      socket.emit("leaveproductsroom");
    };
  }, []);

  // Load all products and set them in Data
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getProducts = async () => {
      try {
        const response = await axiosPrivate.get("/api/products/getfullproducts");
        isMounted && setData(response.data);
      } catch (err) {
        navigate("/login", { state: { from: location }, replace: true });
      }
    };
    const getListProducts = async () => {
      try {
        const response = await axiosPrivate.get("/api/products/getproducts");
        isMounted && setListData(response.data);
      } catch (err) {
        navigate("/login", { state: { from: location }, replace: true });
      }
    };
    getProducts();
    getListProducts();
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [reloaddata]);

  // Filter
  useEffect(() => {
    if (data && data.length > 0) {
      if (productfilter) {
        let searchtext = productfilter.split([", "]);
        let tempfiltereddata = data.filter((item) =>
          searchtext.some(
            (el) =>
              item.productGroup?.toLowerCase().includes(el.toLowerCase()) ||
              item.prodName?.toLowerCase().includes(el.toLowerCase()) ||
              item.prodCatName?.toLowerCase().includes(el.toLowerCase()) ||
              item.abbreviation?.toLowerCase().includes(el.toLowerCase()) ||
              item.companyCode?.toLowerCase().includes(el.toLowerCase()) ||
              item.country?.toLowerCase().includes(el.toLowerCase())
          )
        );
        setProductGroups(tempfiltereddata.groupBy("productGroup"));
      } else {
        setProductGroups(data.groupBy("productGroup"));
      }
    }
  }, [productfilter, data]);

  // Group by function
  Array.prototype.groupBy = function (key) {
    return this.reduce(function (groups, item) {
      const val = item[key];
      groups[val] = groups[val] || [];
      groups[val].push(item);
      return groups;
    }, {});
  };

  // UPDATE PROD STATES
  // Update Prod Group State
  useEffect(() => {
    if (selectedProdGroup && productGroups) {
      setSingleProdGroupData(productGroups[selectedProdGroup].groupBy("prodCatName"));
    }
  }, [selectedProdGroup, productGroups]);
  // Update Prod Cat Name State
  useEffect(() => {
    if (productGroups && selectedProdGroup && selectedProdCatName && singleProdGroupData) {
      setSingleProdCatNameData(singleProdGroupData[selectedProdCatName].groupBy("prodName"));
    } else {
      setSingleProdCatNameData([]);
    }
  }, [selectedProdCatName, singleProdGroupData]);
  // Update ProdName State
  useEffect(() => {
    if (selectedProdName && singleProdCatNameData) {
      setSingleProdNameData(singleProdCatNameData[selectedProdName].groupBy("companyCode"));
    } else {
      setSingleProdNameData([]);
    }
  }, [selectedProdName]);

  // Clean up
  const cleanProdSelections = () => {
    setShowProdGroups(true);
    setSelectedProdGroup("");
    setSelectedProdCatName("");
    setSelectedProdCatNameID();
    setSelectedProdName("");
    setSingleProdGroupData({});
    setProdGroupEdits({ prodGroupID: "", productGroup: "" });
  };

  const leaveroom = (item) => {
    return new Promise((resolve, reject) => {
      socket.emit("leaveproductRoom", selectedProduct.productID);
      resolve();
    });
  };

  // Select Product
  const selectProduct = async (item) => {
    if (selectedProduct && selectedProduct.productID) {
      await leaveroom(item);
    }
    setShowProdDetails(true);
    setSelectedProduct(item);
    setSelectedProducer(item.companyCode);
    if (location.pathname === "/admin/products") {
      navigate("/admin/products/productdetails", { state: { from: location }, replace: true });
    }
    if (item.productID) {
      socket.emit("joinproductRoom", item.productID);
    }
  };

  //UPDATE FUNCTIONS
  const updateProdGroup = async () => {
    const response = await axiosPrivate.post("/api/products/updateprodgroup", {
      prodGroupEdits,
    });
    if (response.data.msg === "Saved") {
      setReloaddata(!reloaddata);
      cleanProdSelections();
    }
  };
  const updateProdCatName = async () => {
    const response = await axiosPrivate.post("/api/products/updateprodcatname", {
      prodCatNameEdits,
    });
    if (response.data.msg === "Saved") {
      setReloaddata(!reloaddata);
      setSelectedProdCatName("");
      setSelectedProdCatNameID(null);
    }
  };
  const updateProdName = async () => {
    const response = await axiosPrivate.post("/api/products/updateprodname", {
      prodNameEdits,
    });
    if (response.data.msg === "Saved") {
      setSelectedProdName("");
      setSelectedProdCatName("");
      setReloaddata(!reloaddata);
    }
  };

  // Handle Prod Cat Name Select
  const handleProdCatNameSelect = (item) => {
    setProdNameEdits({
      ...prodNameEdits,
      ["prodCatNameID"]: item["prodCatNameID"],
      ["prodCatName"]: item["prodCatName"],
    });
  };
  // Handle Prod Group Select
  const handleProdGroupSelect = (item) => {
    setProdNameEdits({
      ...prodNameEdits,
      ["prodGroupID"]: item["prodGroupID"],
      ["productGroup"]: item["productGroup"],
    });
  };
  // Handle BUNIT Select
  const handleBUnitSelect = (item) => {
    setProdNameEdits({
      ...prodNameEdits,
      ["BUID"]: item["BUID"],
      ["businessUnit"]: item["businessUnit"],
    });
  };
  // Handle IMO Select
  const handleIMOGroupSelect = (item) => {
    setProdNameEdits({
      ...prodNameEdits,
      ["IMOID"]: item["IMOID"],
      ["IMO"]: item["IMO"],
    });
  };
  // Handle Input Edits
  const handleProdNameEdits = (e) => {
    setProdNameEdits({
      ...prodNameEdits,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className='productList'>
      {/* ADD PROD MODAL */}
      <AddProdModal
        show={showAddProdModal}
        setShow={setShowAddProdModal}
        setReloaddata={setReloaddata}
        reloaddata={reloaddata}
      />
      {/* HEADER */}
      <div className='productListHeader'>
        <div className='productListSubheader'>
          {!viewlist && <h1>Product Groups</h1>}
          {viewlist && <h1>Product List</h1>}

          {/* BUTTON TO SHOW ALL PRODGROUPS */}
          {!showProdGroups &&
            !viewlist && ( // show only when not in list view and not in full prodgroup view
              <h3
                onClick={(e) => {
                  cleanProdSelections();
                }}
              >
                (Show All)
              </h3>
            )}
        </div>

        {/* TOP RIGHT MENU TO DISPLAY AS LIST OR CARD VIEW */}
        <div className='viewproductsas'>
          <p>View as:</p>
          <FontAwesomeIcon
            className='viewprodicon'
            icon={faList}
            onClick={(e) => {
              setViewlist(true);
            }}
          />
          <FontAwesomeIcon
            className='viewprodicon'
            icon={faAddressCard}
            onClick={(e) => {
              setViewlist(false);
            }}
          />
          <FontAwesomeIcon className='viewprodicon' icon={faPlusSquare} onClick={(e) => setShowAddProdModal(true)} />
        </div>
      </div>

      {/* SEARCH FIELD FOR PRODGROUP VIEW */}
      {showProdGroups &&
        !viewlist && ( // show only when not in list view
          <input
            className='mainproductfilter'
            placeholder='search'
            type='text'
            value={productfilter}
            onChange={(e) => {
              setProductfilter(e.target.value);
            }}
          />
        )}
      {/* VIEWS */}
      <div className='productListContent'>
        {showProdGroups && !viewlist && (
          // FULL PRODGROUP VIEW
          <ProductGroups
            productGroups={productGroups}
            setShowProdGroups={setShowProdGroups}
            setSelectedProdGroup={setSelectedProdGroup}
            setProdGroupEdits={setProdGroupEdits}
          />
        )}
        {viewlist && (
          // PRODUCTLIST VIEW
          <ListWithFilters
            data={listdata}
            columns={["productGroup", "prodCatName", "abbreviation", "companyCode", "country"]}
            onRowClick={selectProduct}
            rowID={"productID"}
            // editableRows={true}
            sortable={true}
            sortDirections={["ASC", "ASC", "ASC", "NON", "NON"]}
            placeHolders={true}
            rowIndex={false}
            placeHolderList={["Product Group", "Category", "Product Name", "Supplier", "Country"]}
          />
        )}
        {!showProdGroups && !viewlist && (
          //PROD SELECTOR VIEW
          <div className='singleProdGroup'>
            <h2
              className='prodgrouph3'
              onClick={(e) => {
                setSelectedProdCatName("");
                setSelectedProdName("");
                setSelectedProducer("");
              }}
            >
              {selectedProdGroup}
            </h2>
            <div className='productSelectorMenu'>
              {/* PROD CAT NAME SELECTOR */}
              <ProdCatNameListSelector
                singleProdGroupData={singleProdGroupData}
                selectedProdCatName={selectedProdCatName}
                setSelectedProdCatName={setSelectedProdCatName}
                setSelectedProdCatNameID={setSelectedProdCatNameID}
                setShowAddProdCatName={setShowAddProdCatName}
                setSelectedProdName={setSelectedProdName}
                setShowProdDetails={setShowProdDetails}
                setSelectedProduct={setSelectedProduct}
                setSelectedProducer={setSelectedProducer}
                setProdCatNameEdits={setProdCatNameEdits}
                setEditingPCN={setEditingPCN}
                selectedProduct={selectedProduct}
              />
              {/* PROD NAME SELECTOR */}
              <ProdNameListSelector
                singleProdCatNameData={singleProdCatNameData}
                selectedProdName={selectedProdName}
                setSelectedProdName={setSelectedProdName}
                setShowProdDetails={setShowProdDetails}
                setSelectedProduct={setSelectedProduct}
                setSelectedProducer={setSelectedProducer}
                setProdNameEdits={setProdNameEdits}
                setEditingPN={setEditingPN}
                selectedProduct={selectedProduct}
              />
              {/* PROD SELECTOR */}
              <ProdSelector
                singleProdNameData={singleProdNameData}
                selectedProducer={selectedProducer}
                setSelectedProducer={setSelectedProducer}
                setShowProdDetails={setShowProdDetails}
                setSelectedProduct={setSelectedProduct}
                selectedProduct={selectedProduct}
              />
            </div>
            {selectedProdGroup && !selectedProdCatName && (
              // EDIT PRODGROUP FORM
              <div className='productsForm'>
                <h3>Edit ProdGroup:</h3>
                <form>
                  <div className='form-item'>
                    <label htmlFor=''>ProdGroupID:</label>
                    <input readOnly style={{ background: "var(--gray)" }} value={prodGroupEdits.prodGroupID} />
                  </div>
                  <div className='form-item'>
                    <label htmlFor=''>ProdGroup:</label>
                    <input
                      value={prodGroupEdits.productGroup}
                      onChange={(e) =>
                        setProdGroupEdits({
                          ...prodGroupEdits,
                          ["productGroup"]: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className='form-buttons'>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setSelectedProdGroup("");
                        cleanProdSelections();
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      className='mainbutton'
                      onClick={(e) => {
                        e.preventDefault();
                        updateProdGroup();
                      }}
                    >
                      Save Edits
                    </button>
                  </div>
                </form>
              </div>
            )}
            {selectedProdCatName && !selectedProdName && editingPCN && (
              // EDIT PRODCATNAME FORM
              <div className='productsForm'>
                <h3>Edit ProdCatName:</h3>
                <form>
                  <div className='form-item'>
                    <label htmlFor=''>ProdCatNameID:</label>
                    <input readOnly style={{ background: "var(--gray)" }} value={prodCatNameEdits.prodCatNameID} />
                  </div>
                  <div className='form-item'>
                    <label htmlFor=''>ProdCatName:</label>
                    <input
                      value={prodCatNameEdits.prodCatName}
                      onChange={(e) => {
                        setProdCatNameEdits({
                          ...prodCatNameEdits,
                          ["prodCatName"]: e.target.value,
                        });
                      }}
                    />
                  </div>
                  <div className='form-buttons'>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setSelectedProdCatName("");
                        setSelectedProdCatNameID();
                        setEditingPCN(false);
                        setProdCatNameEdits({ prodCatName: "", prodCatNameID: "" });
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      className='mainbutton'
                      onClick={(e) => {
                        e.preventDefault();
                        updateProdCatName();
                      }}
                    >
                      Save Edits
                    </button>
                  </div>
                </form>
              </div>
            )}
            {selectedProdCatName && selectedProdName && editingPN && (
              // EDIT PRODNAME FORM
              <div className='productsForm'>
                <h3>Edit ProdName:</h3>
                <form>
                  <div className='form-item'>
                    <label htmlFor=''>ProdNameID:</label>
                    <input style={{ background: "var(--gray)" }} readOnly value={prodNameEdits?.prodNameID} />
                  </div>
                  <div className='form-item'>
                    <label htmlFor=''>ProdGroup:</label>
                    <SearchField
                      searchURL='/api/products/getprodgroups'
                      value={prodNameEdits.productGroup}
                      valueName='productGroup'
                      valueID='prodGroupID'
                      style={{ width: "135px" }}
                      onItemSelect={handleProdGroupSelect}
                    />
                  </div>
                  <div className='form-item'>
                    <label htmlFor=''>ProdCatName:</label>
                    <SearchField
                      searchURL='/api/products/getprodcatnames'
                      value={prodNameEdits.prodCatName}
                      valueName='prodCatName'
                      valueID='prodCatNameID'
                      style={{ width: "135px" }}
                      onItemSelect={handleProdCatNameSelect}
                    />
                  </div>
                  <div className='form-item'>
                    <label htmlFor=''>Abbreviation:</label>
                    <input
                      name='abbreviation'
                      onChange={(e) => {
                        handleProdNameEdits(e);
                      }}
                      value={prodNameEdits?.abbreviation}
                    />
                  </div>
                  <div className='form-item'>
                    <label htmlFor=''>ProdName:</label>
                    <input
                      name='prodName'
                      onChange={(e) => {
                        handleProdNameEdits(e);
                      }}
                      value={prodNameEdits?.prodName}
                    />
                  </div>
                  <div className='form-item'>
                    <label htmlFor=''>BusinessUnit:</label>
                    <SearchField
                      searchURL='/api/products/getbunits'
                      value={prodNameEdits.businessUnit}
                      valueName='businessUnit'
                      valueID='BUID'
                      style={{ width: "135px" }}
                      onItemSelect={handleBUnitSelect}
                    />
                  </div>
                  <div className='form-item'>
                    <label htmlFor=''>IMO:</label>
                    <SearchField
                      searchURL='/api/products/getimogroups'
                      value={prodNameEdits.IMO}
                      valueName='IMO'
                      valueID='IMOID'
                      style={{ width: "135px" }}
                      onItemSelect={handleIMOGroupSelect}
                    />
                  </div>
                  <div className='form-buttons'>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setSelectedProdName("");
                        setProdNameEdits();
                        setEditingPN(false);
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      className='mainbutton'
                      onClick={(e) => {
                        e.preventDefault();
                        updateProdName();
                      }}
                    >
                      Save Edits
                    </button>
                  </div>
                </form>
              </div>
            )}
          </div>
        )}
        {singleProdNameData && selectedProducer ? (
          // PROD DETAILS OUTLET
          <Outlet context={[showProdDetails, selectedProduct]} />
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default Products;

//FILTER ALTERNATIVE
// let tempfiltereddata = data.filter(
//   (item) =>
//     item.productGroup
//       .toLowerCase()
//       .includes(productfilter.toLowerCase()) ||
//     item.prodName.toLowerCase().includes(productfilter.toLowerCase()) ||
//     item.prodCatName
//       .toLowerCase()
//       .includes(productfilter.toLowerCase()) ||
//     item.abbreviation
//       .toLowerCase()
//       .includes(productfilter.toLowerCase()) ||
//     item.companyCode
//       .toLowerCase()
//       .includes(productfilter.toLowerCase()) ||
//     item.country.toLowerCase().includes(productfilter.toLowerCase())
// );
// setFilteredData(tempfiltereddata);
